// <s-copy-code> copies its data-code to the clipboard when its button sends the --copy command,
// swaps the visible label to the "copied" text briefly, and announces the result politely.
class CopyCode extends HTMLElement {
  #controller = null;
  #resetTimer = 0;
  #rafId = 0;

  connectedCallback() {
    this.#controller = new AbortController();
    this.addEventListener('command', (event) => {
      if (event.command === '--copy') this.#copy();
    }, { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
    clearTimeout(this.#resetTimer);
    cancelAnimationFrame(this.#rafId);
  }

  async #copy() {
    const code = this.dataset.code;
    if (!code) return;
    const label = this.querySelector('[data-copy-label]');
    const status = this.querySelector('[data-copy-status]');
    let message = this.dataset.copiedText;
    try {
      await navigator.clipboard.writeText(code);
    } catch {
      message = this.dataset.errorText;
    }
    if (label) {
      label.textContent = message;
      clearTimeout(this.#resetTimer);
      this.#resetTimer = setTimeout(() => { label.textContent = this.dataset.copyText; }, 2000);
    }
    if (status) {
      cancelAnimationFrame(this.#rafId);
      status.textContent = '';
      this.#rafId = requestAnimationFrame(() => { status.textContent = message; });
    }
  }
}

if (!customElements.get('s-copy-code')) {
  customElements.define('s-copy-code', CopyCode);
}
